/* eslint-disable */
import { StyleHelper, LineHeightCalculator, BorderColorParser, SizeConverter, SidesParser, RGBParser, TransformByMatrix2D, ConvertDecToRom, SvgToPng, workerResolver } from './Helpers';
import colorParseFunction from 'color-parse';

/**
 *  Returns object, that contains element, tag-name, child-nodes and styles
 */

const colorParse = (data) => colorParseFunction(data ?? '');
const getBasicNodeData = (element) => {
    return {
        originalElement: element,
        childNodes: element.childNodes || [],
        computedStyles: StyleHelper.getStyle(element),
        beforeComputedStyles: StyleHelper.getStyle(element, ":before"),
        afterComputedStyles: StyleHelper.getStyle(element, ":after"),
        markerComputedStyles: StyleHelper.getStyle(element, ":marker"),
        tagName: element.tagName
    };
};

export const ESIGN_ATTRIBUTES = {
    FIELD_ID: 'data-esign-field-id',
    FIELD_TYPE: 'data-esign-field-type',
    SIGNER_ID: 'data-esign-id',
    SIGNER_TYPE: 'data-esign-h',
    IS_OPTIONAL: 'data-esign-optional',
    TEXT_ALIGN_X: 'data-esign-text-align-x',
    TEXT_VALIDATION: 'data-esign-validation',
    TEXT_LINE_COUNT: 'data-esign-text-multiline',
    TEXT_FONT_SIZE: 'data-esign-text-font-size',
    TEXT_LENGTH_LINE: 'data-esign-text-length',
};

const needToProcessPseudoElement = (pElement) => {
    if (!pElement) {
        return false;
    }
    const content = pElement.content;
    if (!content || content === "none" || content === "normal") {
        return false;
    }
    return (
        (!pElement.display || pElement.display !== "inline") &&
        (!pElement.position || pElement.position !== "static") &&
        !(!pElement.display && !pElement.position)
    )
}


/**
 *  Selector that excludes inline elements
 */
const elementSelector = "*:not(a):not(b):not(form):not(u):not(small):not(abbr):not(legend):not(address):not(link):not(area):not(mark):not(audio):not(meter):not(b):not(nav):not(cite):not(optgroup):not(code):not(option):not(del):not(q):not(details):not(dfn):not(select):not(command):not(source):not(datalist):not(span):not(em):not(strong):not(font):not(sub):not(i):not(summary):not(iframe):not(sup):not(img):not(tbody):not(input):not(td):not(ins):not(time):not(kbd):not(var)";

const inlineTags = "a|b|small|form|u|abbr|legend|address|link|area|mark|audio|meter|b|nav|cite|optgroup|code|option|del|q|details|dfn|select|command|source|datalist|span|em|strong|font|sub|i|summary|iframe|sup|img|tbody|input|td|ins|time|kbd|var".split('|');

const transformMatrixRegex = /matrix\s?\((\s*\-?\d+(\.\d+)?\,?){6}\)/;

const nbsp = String.fromCharCode(160);

const CANVAS_NAMES = ['canvasTarget', 'header-canvas']

/**
 * Method that draw pseudo-elements;
 */
const processPseudoElementAsync = async (
    beforeOrAfter,
    pdfWorker,
    computedStyles,
    parentComputedStyles,
    parentDomRect,
    pageDomRect,
    hqImages = false,
    parentTextContentWidth = 0
) => {
    const { position } = computedStyles;
    const parentDisplay = parentComputedStyles.display;
    const parentFlexDirection = parentComputedStyles.flexDirection;
    if (position !== "absolute") {
        if (beforeOrAfter === "after") {
            switch (parentDisplay) {
                case "flex": {
                    const height = SizeConverter(computedStyles.height);
                    const width = SizeConverter(computedStyles.width);
                    const parentDomRectCopy = {};
                    if (parentFlexDirection === "row") {
                        parentDomRectCopy.top = parentDomRect.top;
                        parentDomRectCopy.left = parentDomRect.left + parentTextContentWidth;
                        parentDomRectCopy.width = width - parentTextContentWidth;
                        parentDomRectCopy.height = height;
                        parentDomRect = parentDomRectCopy;
                    }
                    //else if (parentFlexDirection === "column") {
                    //    parentDomRectCopy.width = width;
                    //    parentDomRectCopy.height = height;
                    //    parentDomRectCopy.top = parentDomRect.y + height;
                    //    parentDomRectCopy.left = parentDomRect.left;
                    //}
                    break;
                }
            }
        }
    }

    let x = SizeConverter(parentDomRect.left - pageDomRect.left) + SizeConverter(parentComputedStyles.paddingLeft || 0);
    let y = SizeConverter(parentDomRect.top - pageDomRect.top);

    let { borderColor, borderTopColor, borderBottomColor, borderLeftColor, borderRightColor, borderWidth } = computedStyles;
    let { opacity, alignItems, justifyContent, color, outline, transform } = computedStyles;
    let { backgroundColor, backgroundImage, backgroundSize } = computedStyles;
    let { fontSize, fontFamily, fontStyle, textTransform } = computedStyles;
    let { content } = computedStyles;

    let { width, height } = computedStyles;
    width = SizeConverter(width);
    height = SizeConverter(height);

    let backgroundWidth, backgroundHeight;
    if (transform && transform.match(transformMatrixRegex)) {
        const matrixValues = transform.match(/\-?\d+(\.\d+)?/g).map(value => parseFloat(value)); // getting array of 6 numbers
        const borderWidthValues = SidesParser(borderWidth);
        const top = SizeConverter(borderWidthValues.top);
        const bottom = SizeConverter(borderWidthValues.bottom);
        const left = SizeConverter(borderWidthValues.left);
        const right = SizeConverter(borderWidthValues.right);

        const localeCoords = {
            topLeft: {
                x: -width / 2 - left,
                y: -height / 2 - top / 2
            },
            bottomLeft: {
                x: -width / 2 - left,
                y: height / 2 + bottom / 2
            },
            topRight: {
                x: width / 2 + right,
                y: -height / 2 - top / 2
            },
            bottomRight: {
                x: width / 2 + right,
                y: height / 2 + bottom / 2
            },
            topBorderLeft: {
                x: -(width / 2 + left),
                y: -(height + top) / 2
            },
            topBorderRight: {
                x: width / 2 + right,
                y: -(height + top) / 2
            },

            bottomBorderLeft: {
                x: -(width / 2 + left),
                y: (height + bottom) / 2
            },
            bottomBorderRight: {
                x: width / 2 + right,
                y: (height + bottom) / 2
            },

            leftBorderTop: {
                x: -(width + left) / 2,
                y: -height / 2 - top
            },
            leftBorderBottom: {
                x: -(width + left) / 2,
                y: height / 2 + bottom
            },

            rightBorderTop: {
                x: (width + right) / 2,
                y: -height / 2 - top
            },
            rightBorderBottom: {
                x: (width + right) / 2,
                y: height / 2 + bottom
            },
            centerLeft: {
                x: -width / 2,
                y: 0.
            },
            centerRight: {
                x: width / 2,
                y: 0
            },
            centerTop: {
                x: 0,
                y: height / 2,
            },
            centerBottom: {
                x: 0,
                y: - height / 2
            }
        }
        const localeCoordsPropNames = Object.keys(localeCoords);
        const transformedCoords = {};
        for (let i = 0; i < localeCoordsPropNames.length; i++) {
            transformedCoords[localeCoordsPropNames[i]] =
                TransformByMatrix2D(
                    matrixValues,
                    localeCoords[localeCoordsPropNames[i]].x,
                    localeCoords[localeCoordsPropNames[i]].y
                );
        }
        const centerIndentX = (left - right);
        const centerIndentY = (top - bottom);
        let centerIndent = { x: 0, y: 0 };
        if (centerIndentX || centerIndentY) {
            centerIndent = TransformByMatrix2D(matrixValues, centerIndentX, centerIndentY);
        }
        let elementCenterX = x + SizeConverter(parentDomRect.width) / 2 + centerIndent.x;
        let elementCenterY = y + SizeConverter(parentDomRect.height) / 2 + centerIndent.y;
        if (borderWidth) {
            let borderColorValues;
            if (top > 0) {
                //top border
                borderColorValues = RGBParser(borderTopColor);
                await workerResolver(pdfWorker, `setLineWidth`, top);
                await workerResolver(pdfWorker, `setDrawColor`, borderColorValues[0], borderColorValues[1], borderColorValues[2]);
                const leftX = elementCenterX + transformedCoords.topBorderLeft.x;
                const leftY = elementCenterY + transformedCoords.topBorderLeft.y;
                const rightX = elementCenterX + transformedCoords.topBorderRight.x;
                const rightY = elementCenterY + transformedCoords.topBorderRight.y;
                await workerResolver(pdfWorker, `line`, leftX, leftY, rightX, rightY);
            }
            if (bottom > 0) {
                //bottom border
                borderColorValues = RGBParser(borderBottomColor);
                await workerResolver(pdfWorker, `setLineWidth`, bottom);
                await workerResolver(pdfWorker, `setDrawColor`, borderColorValues[0], borderColorValues[1], borderColorValues[2]);
                const leftX = elementCenterX + transformedCoords.bottomBorderLeft.x;
                const leftY = elementCenterY + transformedCoords.bottomBorderLeft.y;
                const rightX = elementCenterX + transformedCoords.bottomBorderRight.x;
                const rightY = elementCenterY + transformedCoords.bottomBorderRight.y;
                await workerResolver(pdfWorker, `line`, leftX, leftY, rightX, rightY);
            }
            if (left > 0) {
                //left border
                borderColorValues = RGBParser(borderLeftColor);
                await workerResolver(pdfWorker, `setLineWidth`, left);
                await workerResolver(pdfWorker, `setDrawColor`, borderColorValues[0], borderColorValues[1], borderColorValues[2]);
                const topX = elementCenterX + transformedCoords.leftBorderTop.x;
                const topY = elementCenterY + transformedCoords.leftBorderTop.y;
                const bottomX = elementCenterX + transformedCoords.leftBorderBottom.x;
                const bottomY = elementCenterY + transformedCoords.leftBorderBottom.y;
                await workerResolver(pdfWorker, `line`, topX, topY, bottomX, bottomY);
            }
            if (right > 0) {
                //right border
                borderColorValues = RGBParser(borderRightColor);
                await workerResolver(pdfWorker, `setLineWidth`, right);
                await workerResolver(pdfWorker, `setDrawColor`, borderColorValues[0], borderColorValues[1], borderColorValues[2]);
                const topX = elementCenterX + transformedCoords.rightBorderTop.x;
                const topY = elementCenterY + transformedCoords.rightBorderTop.y;
                const bottomX = elementCenterX + transformedCoords.rightBorderBottom.x;
                const bottomY = elementCenterY + transformedCoords.rightBorderBottom.y;
                await workerResolver(pdfWorker, `line`, topX, topY, bottomX, bottomY);
            }
        }
        if (backgroundColor) {
            const _backgroundColor = RGBParser(backgroundColor)
            if (_backgroundColor.length === 3 || _backgroundColor[3] !== 0) {
                await workerResolver(pdfWorker, `setLineWidth`, height);
                await workerResolver(pdfWorker, `setDrawColor`, _backgroundColor[0], _backgroundColor[1], _backgroundColor[2]);
                const x1 = elementCenterX + transformedCoords.centerLeft.x;
                const y1 = elementCenterY + transformedCoords.centerLeft.y;
                const x2 = elementCenterX + transformedCoords.centerRight.x;
                const y2 = elementCenterY + transformedCoords.centerRight.y;
                await workerResolver(pdfWorker, `line`, x1, y1, x2, y2);
            }
        }
        if (content) {
            content = content.replace(/^\"|\"$/g, '');
            if (textTransform) {
                if (textTransform.includes("uppercase")) {
                    content = content.toUpperCase();
                } else if (textTransform.includes("lowercase")) {
                    content = content.toLowerCase();
                }
            }
            await workerResolver(pdfWorker, `setFontSize`, SizeConverter(fontSize));
            const fontName = fontFamily.split(',')[0].replace(/\"/g, '');
            await workerResolver(pdfWorker, `loadCustomFontAsync`, fontName, fontStyle || "normal");
            await workerResolver(pdfWorker, `setFont`, fontName, fontStyle);

            let contentX = elementCenterX + transformedCoords.centerLeft.x;
            let contentY = elementCenterY + transformedCoords.centerLeft.y;

            let newX, newY;
            if (alignItems) {
                if (alignItems === "center") {
                    const lineHeight = SizeConverter(Math.min(LineHeightCalculator(computedStyles), fontSize));
                    newY = lineHeight / 2;
                }
            }
            if (justifyContent) {
                if (justifyContent === "center") {
                    const textWidth = await workerResolver(pdfWorker, `getTextWidth`, content);
                    newX = - textWidth / 2;
                }
            }

            if (newX || newY) {
                let newTextCoordinates;
                if (newX && newY) {
                    newTextCoordinates = TransformByMatrix2D(matrixValues, newX, newY);
                } else if (newY) {
                    newX = localeCoords.centerLeft.x;
                    newTextCoordinates = TransformByMatrix2D(matrixValues, newX, newY);
                } else if (newX) {
                    newY = localeCoords.centerLeft.y;
                    newTextCoordinates = TransformByMatrix2D(matrixValues, newX, newY);
                }
                contentX = elementCenterX + newTextCoordinates.x /*- newX) + width / 2 + left / 2;*/
                contentY = elementCenterY + newTextCoordinates.y/* /*+ newY) + height / 2 + top / 2;*/
            }
            const rotateAngle = Math.asin(matrixValues[1]) * 180 / Math.PI * -1;

            if (color) {
                const colorValues = RGBParser(color);
                if (colorValues.length === 3 || colorValues[3] !== 0) {
                    await workerResolver(pdfWorker, `setTextColor`, colorValues[0], colorValues[1], colorValues[2]);
                }
            }
            await workerResolver(pdfWorker, `text`, content, contentX, contentY, rotateAngle);
        }
    } else {
        let values;
        let top = 0, bottom = 0, left = 0, right = 0;
        if (borderWidth) {
            let borderColors = BorderColorParser(borderColor);
            if (!borderColors) {
                borderColors = colorParse(borderColor).values
                if (!borderColors.length) {
                    borderColors = {
                        top: ("rgb(0, 0, 0)"),
                        bottom: ("rgb(0, 0, 0)"),
                        right: ("rgb(0, 0, 0)"),
                        left: ("rgb(0, 0, 0)")
                    }
                }
            }
            const borderWidthValues = SidesParser(borderWidth);
            top = SizeConverter(borderWidthValues.top);
            bottom = SizeConverter(borderWidthValues.bottom);
            left = SizeConverter(borderWidthValues.left);
            right = SizeConverter(borderWidthValues.right);

            if (borderColors) {
                //line generating
                if (top > 0) {
                    //top line
                    values = colorParse(borderColors.top).values;
                    await workerResolver(pdfWorker, `setDrawColor`, values[0], values[1], values[2]);
                    await workerResolver(pdfWorker, `setLineWidth`, top);
                    await workerResolver(pdfWorker, `line`, x, y + top / 2, x + width, y + top / 2);
                }
                if (bottom > 0) {
                    //bottom line
                    values = colorParse(borderColors.bottom).values;
                    await workerResolver(pdfWorker, `setDrawColor`, values[0], values[1], values[2]);
                    await workerResolver(pdfWorker, `setLineWidth`, bottom);
                    await workerResolver(pdfWorker, `line`, x, y + height - bottom / 2, x + width, y + height - bottom / 2);
                }
                if (left > 0) {
                    //left line
                    values = colorParse(borderColors.left).values;
                    await workerResolver(pdfWorker, `setDrawColor`, values[0], values[1], values[2]);
                    await workerResolver(pdfWorker, `setLineWidth`, left);
                    await workerResolver(pdfWorker, `line`, x + left / 2, y, x + left / 2, y + height);
                }
                if (right > 0) {
                    //right line
                    values = colorParse(borderColors.right).values;
                    await workerResolver(pdfWorker, `setDrawColor`, values[0], values[1], values[2]);
                    await workerResolver(pdfWorker, `setLineWidth`, right);
                    await workerResolver(pdfWorker, `line`, x + width - right / 2, y, x + width - right / 2, y + height);
                }
            }
        }

        if (backgroundColor) {
            const _backgroundColor = RGBParser(backgroundColor);
            await workerResolver(pdfWorker, `setDrawColor`, 0);
            await workerResolver(pdfWorker, `setFillColor`, _backgroundColor[0], _backgroundColor[1], _backgroundColor[2]);
            await workerResolver(pdfWorker, `rect`, x + left, y + top, width - left - right, height - top - bottom, 'F');
        }
        if (content) {
            content = content.replace(/^\"|\"$/g, '');
            if (textTransform) {
                if (textTransform.includes("uppercase")) {
                    content = content.toUpperCase();
                }
                else if (textTransform.includes("lowercase")) {
                    content = content.toLowerCase();
                }
            }
            await workerResolver(pdfWorker, `setFontSize`, SizeConverter(fontSize));
            const fontName = fontFamily.split(',')[0].replace(/\"/g, '');
            await workerResolver(pdfWorker, `loadCustomFontAsync`, fontName, fontStyle || "normal");
            await workerResolver(pdfWorker, `setFont`, fontName, fontStyle);
            if (color) {
                const colorValues = RGBParser(color);
                if (colorValues.length === 3 || colorValues[3] !== 0) {
                    await workerResolver(pdfWorker, `setTextColor`, colorValues[0], colorValues[1], colorValues[2]);
                }
            }
            await workerResolver(pdfWorker, `text`, content, x, y + (SizeConverter(fontSize) || 0));
        }
        if (outline) {
            const outlineWidth = SizeConverter(outline.match(/\d+\.*\d*([a-z]{2})/i)[0]);
            const outlineColor = RGBParser(outline);
            if ((outlineColor.length === 3 || outlineColor[3] !== 0) && outlineWidth) {
                await workerResolver(pdfWorker, `setDrawColor`, outlineColor[0], outlineColor[1], outlineColor[2]);
                await workerResolver(pdfWorker, `setLineWidth`, outlineWidth);
                await workerResolver(pdfWorker, `line`, x - outlineWidth, y - outlineWidth / 2, x + width + outlineWidth, y - outlineWidth / 2);                   // top line
                await workerResolver(pdfWorker, `line`, x - outlineWidth, y + height + outlineWidth / 2, x + width + outlineWidth, y + height + outlineWidth / 2); // bottom line
                await workerResolver(pdfWorker, `line`, x - outlineWidth / 2, y - outlineWidth, x - outlineWidth / 2, y + height + outlineWidth);                  // left line
                await workerResolver(pdfWorker, `line`, x + width + outlineWidth / 2, y - outlineWidth, x + width + outlineWidth / 2, y + height + outlineWidth);  // right line
            }
        }
    }
    if (backgroundImage && backgroundImage.includes('url(')) {
        backgroundSize = backgroundSize && backgroundSize.match(/\d+(\.\d+)*\D+[ ]*/g);
        if (backgroundSize) {
            backgroundWidth = SizeConverter(backgroundSize[0]);
            backgroundHeight = SizeConverter(backgroundSize[1]);
        }
        const urlStartIndex = backgroundImage.indexOf("(") + 1;
        const urlEndIndex = backgroundImage.indexOf(")") - 1;
        let imageSource = backgroundImage.slice(urlStartIndex + 1, urlEndIndex), svgSource;
        if (!buildPDFObjectAsync.imagesCache) {
            buildPDFObjectAsync.imagesCache = [];
        }
        const isCachedImage = await workerResolver(pdfWorker, `isCachedImage`, imageSource);
        let isImageBroken = false;
        if (!isCachedImage) {
            const isSvgImage = await workerResolver(pdfWorker, `isSVGImageAsync`, imageSource);
            if (isSvgImage === undefined) {
                isImageBroken = true;
            }
            if (isSvgImage) {
                svgSource = imageSource;
                imageSource = await SvgToPng(svgSource);
            }
        }
        if (!isImageBroken) {
            const { imageData } = await workerResolver(pdfWorker, `getImage`, {
                svgSource,
                imageSource,
                ...(backgroundWidth && backgroundHeight ? {
                    forcedWidth: backgroundWidth,
                    forcedHeight: backgroundHeight
                } : {})
            });
            if (imageData) {
                if (backgroundWidth && backgroundWidth) {
                    await workerResolver(pdfWorker, `addImage`, imageData, `SLOW`, x, y, backgroundWidth, backgroundHeight);
                } else {
                    await workerResolver(pdfWorker, `addImage`, imageData, `SLOW`, x, y);
                }
            }
        }
    }
}

/**
* Function, that fills the array of paragraphs-metadata based on html-nodes, works recursively
* @param {object} pdfWorker - worker 
* @param {node} documentBody - document's body html-node 
* @param {node} element - current processing element's html-node
* @param {node} pageElement - html-node of page, that includes current element
* @param {Array} paragraphObjects - arrray of metadata to fill (ref)
* @param {boolean} processSigns - is signs need to be processed for ESign
* @param {number} pageIndex - page index
* @param {number} nestingLevel - number, that shows the recursive level (used to draw borders of elements after all content was processed)
* @param {number} parentsBeforePseudoElementOutline - parent's html-node indent, that can be calculated only outside of function
* @param {boolean} hqImages - flag, that set the logic of images conversion (default or high-quality)
* @return void.
*/
export const buildPDFObjectAsync = async ({
    pdfWorker,
    documentBody,
    element,
    pageElement,
    paragraphObjects,
    processSigns,
    pageIndex,
    nestingLevel,
    parentsBeforePseudoElementOutline = 0,
    hqImages = false,
    textFormatter,
}) => {
    if (!element) {
        return null;
    }
    if (!buildPDFObjectAsync.svgCanvas) {
        buildPDFObjectAsync.svgCanvas = document.createElement("canvas");
    }
    if (!nestingLevel) {
        nestingLevel = 0;
    }
    nestingLevel++;

    const { parentNode: currElParentNode } = element;
    switch (element.nodeType) {
        case Node.ELEMENT_NODE: {
            const { computedStyles, beforeComputedStyles, afterComputedStyles, originalElement, tagName, childNodes } = getBasicNodeData(element);
            if (computedStyles.visibility === 'hidden' || computedStyles.display === "none") {
                return;
            }
            const parentNode = element.parentNode;
            const domRect = element ? element.getBoundingClientRect() : '';
            const domRectScroll = {
                top: documentBody.scrollTop,
                left: documentBody.scrollLeft
            }
            const pageDomRect = pageElement.getBoundingClientRect();
            const pageDomRectScroll = {
                top: documentBody.scrollTop,
                left: documentBody.scrollLeft
            }
            let x = SizeConverter(domRect.left - pageDomRect.left - (pageDomRectScroll.left | 0) + (domRectScroll.left | 0));
            let y = SizeConverter(domRect.top - pageDomRect.top - (pageDomRectScroll.top | 0) + (domRectScroll.top | 0));
            if (domRect.width && domRect.height) {
                if (!inlineTags.includes(element.tagName.trim().toLowerCase())
                    || element.textContent === nbsp
                    || element.textContent.trim() === '') {
                    if (element.childNodes.length === 1
                        && element.childNodes[0].textContent === ' '
                        && element.outerHTML.indexOf('data-esign-field-id')===-1
                        && element.outerHTML.indexOf('data-grid')===-1) { // if there is an empty cell in the table (normal and repeater), it will be drawn. Without this line in pdf checkboxes and border disappear, because empty cells are not drawn
                        return;
                    }
                    const currElChildNodes = element.childNodes;
                    const elementIsMultipleTimesWrappedInlineTag = (
                        currElChildNodes.length === 1
                        && currElChildNodes[0].nodeType === Node.ELEMENT_NODE
                        && inlineTags.includes(currElChildNodes[0].tagName)
                        && inlineTags.includes(currElTagName)
                    );
                    const parentIsInlineTag = inlineTags.includes(currElParentNode.tagName);
                    const closestParagraphNode = parentIsInlineTag ?
                        element.closest(elementSelector)
                        : currElParentNode;
                    const paragraphTextContent = closestParagraphNode.textContent.trim();

                    if (paragraphTextContent && !elementIsMultipleTimesWrappedInlineTag) {
                        let paragraphObject = paragraphObjects.length
                            ? paragraphObjects.find((object) => object.paragraphNode.isSameNode(closestParagraphNode))
                            : null;
                        const domRectHeight = closestParagraphNode.getBoundingClientRect().height;
                        const cStyles = getBasicNodeData(closestParagraphNode).computedStyles;
                        if (!paragraphObject) {
                            paragraphObject = {
                                items: [],
                                paragraphNode: closestParagraphNode,
                                styles: {
                                    lineHeight: SizeConverter(LineHeightCalculator(cStyles, [...parentNode.childNodes].filter(node => node.nodeType == Node.TEXT_NODE)[0])) + 'pt',
                                    domRectHeight: SizeConverter(domRectHeight),
                                    padding: cStyles.padding,
                                    alignItems: cStyles.alignItems,
                                    textAlign: cStyles.textAlign,
                                    textAlignLast: cStyles.textAlignLast,
                                    justifyContent: cStyles.justifyContent,
                                    borderWidth: cStyles.borderWidth,
                                    textOverflow: cStyles.textOverflow,
                                    whiteSpace: cStyles.whiteSpace
                                }
                            }
                            paragraphObjects.push(paragraphObject);
                        }
                        const currentElementCStyles = getBasicNodeData(element); // QR-4473
                        const itemMarginValues = SidesParser(currentElementCStyles.margin);
                        const widthForPdfConversion = SizeConverter(
                            domRect.width
                            + parseFloat(itemMarginValues.left)
                            + parseFloat(itemMarginValues.right)
                        );
                        const heightForPdfConversion = SizeConverter(domRect.height);
                        if (element.textContent.trimSpaces() || element.clientWidth) {
                            const itemData = {
                                nodeType: element.nodeType,
                                node: element,
                                x: x - SizeConverter(itemMarginValues.left),
                                y,
                                width: `${widthForPdfConversion}pt`,
                                height: `${heightForPdfConversion}pt`
                            };
                            if (element.textContent === nbsp) {
                                const itemsLength = paragraphObject.items.length;
                                if (itemsLength > 0) {
                                    if (paragraphObject.items[itemsLength - 1].nodeType === Node.TEXT_NODE) {
                                        paragraphObject.items[itemsLength - 1].text += nbsp;
                                    } else {
                                        paragraphObject.items[itemsLength - 1].width += itemData.width;
                                    }
                                } else {
                                    paragraphObject.items.push(itemData);
                                }
                            } else {
                                paragraphObject.items.push(itemData);
                            }
                        }
                    }

                    if ([...parentNode.childNodes].filter(node => node.nodeType === Node.TEXT_NODE || (node.tagName && node.tagName.toLowerCase() === 'strong')).length) { // added checking for <strong> tags, because of cases, when parentNode contains not TextNode, but <strong>, that actually text too
                        let paragraphObject = paragraphObjects.length ? paragraphObjects.find(object => object.paragraphNode.isSameNode(parentNode)) : void 0;
                        if (!paragraphObject) {
                            const cStyles = getBasicNodeData(parentNode).computedStyles;
                            const domRectHeight = parentNode.getBoundingClientRect().height;
                            paragraphObject = {
                                items: [],
                                paragraphNode: parentNode,
                                styles: {
                                    lineHeight: SizeConverter(LineHeightCalculator(cStyles, [...parentNode.childNodes].filter(node => node.nodeType == Node.TEXT_NODE)[0])) + 'pt',
                                    domRectHeight: SizeConverter(domRectHeight),
                                    padding: cStyles.padding,
                                    alignItems: cStyles.alignItems,
                                    textAlign: cStyles.textAlign,
                                    textAlignLast: cStyles.textAlignLast,
                                    justifyContent: cStyles.justifyContent,
                                    borderWidth: cStyles.borderWidth,
                                    textOverflow: cStyles.textOverflow,
                                    whiteSpace: cStyles.whiteSpace
                                }
                            }
                            paragraphObjects.push(paragraphObject)
                        }
                        const itemStyles = getBasicNodeData(element).computedStyles;
                        const itemMarginValues = SidesParser(itemStyles.margin)
                        const itemData = {
                            nodeType: element.nodeType,
                            x: x - SizeConverter(itemMarginValues.left),
                            y,
                            node: element,
                            width: SizeConverter(domRect.width + parseFloat(itemMarginValues.left) + parseFloat(itemMarginValues.right)),
                            height: SizeConverter(domRect.height)
                        };
                        if (element.textContent === nbsp) {
                            const itemsLenght = paragraphObject.items.length;
                            if (itemsLenght > 0) {
                                if (paragraphObject.items[itemsLenght - 1].nodeType === Node.TEXT_NODE) {
                                    paragraphObject.items[itemsLenght - 1].text += nbsp;
                                } else {
                                    paragraphObject.items[itemsLenght - 1].width += itemData.width;
                                }
                            } else {
                                paragraphObject.items.push(itemData);
                            }
                        } else {
                            if (!paragraphObject.items
                                .filter((item) => item.node)
                                .find((item) => element.isSameNode(item.node))
                            ) {
                                paragraphObject.items.push(itemData);
                            }
                        }
                    }
                }
            }
            switch (tagName) {
                case `CANVAS`: {
                    let { clientWidth, clientHeight } = originalElement;
                    try {
                        if (element.getContext('2d').getImageData(0, 0, clientWidth, clientHeight).data.some(byte => byte !== 0)) {
                            // if the canvas isn't blank - process it
                            let isExternalDoc = false;
                            const pageElement = element.closest(".page")
                            if (pageElement) {
                                isExternalDoc = pageElement.getAttribute("data-external-doc");
                            }
                            if (isExternalDoc === 'true') {
                                let transform = element.parentNode.style.transform;
                                
                                if (!transform)
                                    transform = window.getComputedStyle(element.parentNode).transform;
                                
                                const match = transform.match(/scale\(([\d.]+)\)/);
                                const pageScale = match ? parseFloat(match[1]) : 1;
                                if (pageScale !== 1) {
                                    clientHeight *= pageScale;
                                    clientWidth *= pageScale;
                                }
                            }

                            const imageData = element.toDataURL("image/jpeg");
                            const barcodeWidth = SizeConverter(clientWidth);
                            const barcodeHeight = SizeConverter(clientHeight);

                            if (CANVAS_NAMES.includes(element.getAttribute('name'))) {
                                if (!buildPDFObjectAsync.barcodeRender_temp) {
                                    buildPDFObjectAsync.barcodeRender_temp = [];
                                }
                                buildPDFObjectAsync.barcodeRender_temp.push((async () => {
                                    await workerResolver(
                                        pdfWorker,
                                        'setDrawColor',
                                        255,
                                        255,
                                        255
                                    );
                                    await workerResolver(
                                        pdfWorker,
                                        'setLineWidth',
                                        (barcodeWidth + 4)
                                    );
                                    await workerResolver(
                                        pdfWorker,
                                        'line',
                                        (x + barcodeWidth / 2),
                                        y - 2,
                                        (x + barcodeWidth / 2),
                                        (y + barcodeHeight + 2)
                                    );
                                    await workerResolver(
                                        pdfWorker,
                                        `addImage`,
                                        imageData.substring(imageData.indexOf(',') + 1),
                                        `SLOW`,
                                        x,
                                        y,
                                        SizeConverter(clientWidth),
                                        SizeConverter(clientHeight)
                                    );
                                }));
                            }
                            else {
                                await workerResolver(pdfWorker, `addImage`, imageData.substring(imageData.indexOf(',') + 1), `SLOW`, x, y, SizeConverter(clientWidth), SizeConverter(clientHeight));
                            }
                        }
                    } catch (exceptionInfo) {
                        // bugreport
                        console.log(exceptionInfo);
                    }
                    break;
                }
                case `IMG`: {
                    const isPagedImage = element.parentNode.isEqualNode(pageElement); // flag, that used in DocumentTracking, where many pictures are the only children of their parent pages (1 page -> 1 picture)
                    let imageSource = element.getAttribute("src") || element.getAttribute("data-src");
                    if (imageSource) {
                        let svgSource;
                        const isCachedImage = await workerResolver(pdfWorker, `isCachedImage`, imageSource);
                        let isImageBroken = false;
                        if (!isCachedImage) {
                            const isSvgImage = await workerResolver(pdfWorker, `isSVGImageAsync`, imageSource);
                            if (isSvgImage === undefined) {
                                isImageBroken = true;
                            }
                            if (isSvgImage) {
                                svgSource = imageSource;
                                imageSource = await SvgToPng(svgSource);
                            }
                        }
                        if (isImageBroken) {
                            break;
                        }
                        const { imageData, width: imageWidth, height: imageHeight } = await workerResolver(pdfWorker, `getImage`, {
                            svgSource,
                            imageSource,
                            isPagedImage
                        });
                        const { left, top, width: elementWidth, height: elementHeight } = element ? element.getBoundingClientRect() : ({ left: 0, top: 0 });
                        const { width, height } = element.offsetParent.getBoundingClientRect();
                        const elementRectScroll = {
                            top: documentBody.scrollTop,
                            left: documentBody.scrollLeft
                        }
                        let resultWidth, resultHeight;
                        if ((imageWidth <= width) && (imageHeight <= height)) {
                            resultWidth = imageWidth;
                            resultHeight = imageHeight;
                        } else if ((imageWidth > width) && (imageHeight <= height)) {
                            resultWidth = width;
                            resultHeight = width / imageWidth * imageHeight;
                        } else if ((imageWidth <= width) && (imageHeight > height)) {
                            resultWidth = height / imageHeight * imageWidth;
                            resultHeight = height;
                        } else if ((imageWidth / width) > (imageHeight / height)) {
                            resultWidth = width;
                            resultHeight = imageHeight * width / imageWidth;
                        } else if ((imageWidth / width) <= (imageHeight / height)) {
                            resultWidth = imageWidth * height / imageHeight;
                            resultHeight = height;
                        }
                        const x = SizeConverter((element.complete ? (left - pageDomRect.left) : (width - resultWidth) / 2) - (pageDomRectScroll.left | 0) + (elementRectScroll.left | 0));
                        const y = SizeConverter(top - pageDomRect.top - (pageDomRectScroll.top | 0) + (elementRectScroll.top | 0));
                        if (imageData) {
                            await workerResolver(
                                pdfWorker,
                                `addImage`,
                                imageData,
                                `SLOW`,
                                x,
                                y,
                                SizeConverter(element.complete ? elementWidth : resultWidth),
                                SizeConverter(element.complete ? elementHeight : resultHeight),
                                imageSource
                            );
                        }
                    }
                    break;
                }
                case 'SVG': case 'svg': {
                    const fontFamily = element.getAttribute('font-family');
                    const fontStyle = element.getAttribute('font-style') || 'normal';
                    const { clientWidth, clientHeight, naturalWidth, naturalHeight } = element;
                    element.setAttribute(`xmlns`, `http://www.w3.org/2000/svg`);
                    element.setAttribute(`xmlns:xlink`, `http://www.w3.org/1999/xlink`);
                    const svgHtml = element.outerHTML.trim();
                    const svgNS = "http://www.w3.org/2000/svg";
                    const svgDoc = new DOMParser().parseFromString(svgHtml, 'image/svg+xml');
                    const defs = svgDoc.createElementNS(svgNS, 'defs');
                    const style = svgDoc.createElementNS(svgNS, 'style');
                    const styleJSON = {
                        ["font-family"]: fontFamily,
                        ["font-style"]: fontStyle,
                        ["font-weight"]: 400
                    };
                    const isCustomFont = await workerResolver(pdfWorker, `isCustomFont`, fontFamily, fontStyle);
                    if (isCustomFont) {
                        const based64Font = await workerResolver(pdfWorker, `getCustomFontDataAsync`, fontFamily, fontStyle);
                        if (based64Font) {
                            styleJSON.src = `url("data:font/ttf;base64,${based64Font}") format("openType")`;
                        }
                    }
                    style.innerHTML = `@font-face { ${Object.keys(styleJSON).map((styleKey) => `${styleKey}: ${styleJSON[styleKey]}`).join(`; `)} }`;
                    defs.appendChild(style);
                    svgDoc.documentElement.appendChild(defs);
                    const svgSource = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svgDoc.documentElement)], {
                        type: 'image/svg+xml'
                    }));
                    const imageSource = await workerResolver(pdfWorker, `isCachedImage`, svgSource) ? svgSource : (await SvgToPng(svgSource));
                    const { imageData } = await workerResolver(pdfWorker, `getImage`, {
                        svgSource,
                        imageSource,
                        hqImages: true
                    });
                    if (imageData) {
                        await workerResolver(pdfWorker, `addImage`, imageData, `PNG`, x, y, SizeConverter(clientWidth), SizeConverter(clientHeight));
                    }
                    break;
                }
                case 'BR': case 'br': {
                    const text = "\n";
                    const itemNode = element.parentNode;
                    const paragraphNode = itemNode.closest(elementSelector);
                    const domRectHeight = paragraphNode.getBoundingClientRect().height;
                    const { computedStyles } = getBasicNodeData(itemNode);
                    const { fontStyle, fontSize, color } = computedStyles;
                    let { fontFamily } = computedStyles;
                    const fontFamilyArr = fontFamily.split(",");
                    if (fontFamilyArr) {
                        for (let i = 0; i < fontFamilyArr.length; i++) {
                            fontFamilyArr[i] = fontFamilyArr[i].trim().replace(/\"|\'|\`/g, "");
                        }
                        fontFamily = fontFamilyArr[0];
                    }
                    const itemData = {
                        nodeType: Node.TEXT_NODE,
                        fontStyle,
                        fontFamily,
                        fontSize: SizeConverter(fontSize),
                        color: `rgb(${colorParse(color ?? '').values.join(', ')})`,
                        text
                    };
                    let paragraphObject = paragraphObjects.find(object => object.paragraphNode.isSameNode(paragraphNode));

                    if (!paragraphObject) {
                        const cStyles = getBasicNodeData(paragraphNode).computedStyles;
                        paragraphObject = {
                            items: [],
                            paragraphNode,
                            styles: {
                                lineHeight: SizeConverter(LineHeightCalculator(cStyles, element)) + 'pt',
                                domRectHeight: SizeConverter(domRectHeight),
                                padding: cStyles.padding,
                                alignItems: cStyles.alignItems,
                                textAlign: cStyles.textAlign,
                                textAlignLast: cStyles.textAlignLast,
                                justifyContent: cStyles.justifyContent,
                                borderWidth: cStyles.borderWidth,
                                textOverflow: cStyles.textOverflow,
                                whiteSpace: cStyles.whiteSpace
                            }
                        }
                        paragraphObjects.push(paragraphObject)
                    }
                    paragraphObject.items.push(itemData);
                    break;
                }
                case 'LI': {
                    const currentItemBasicNodeData = getBasicNodeData(element)
                    const itemStyles = currentItemBasicNodeData.computedStyles;
                    if (itemStyles.display === "list-item") {
                        let markerColor = currentItemBasicNodeData.markerComputedStyles.color;
                        markerColor = markerColor ? RGBParser(markerColor) : [0, 0, 0];
                        await workerResolver(pdfWorker, `setFillColor`, markerColor[0], markerColor[1], markerColor[2]);
                        const needBracket = element.parentNode.className.includes('bracket-list');
                        const postSymbol = needBracket ? ')' : '.';
                        let { listStyleType, listStyle, lineHeight, fontSize, fontFamily, fontStyle } = itemStyles;
                        const fontFamilyArr = fontFamily.split(",");
                        if (fontFamilyArr) {
                            for (let i = 0; i < fontFamilyArr.length; i++) {
                                fontFamilyArr[i] = fontFamilyArr[i].trim().replace(/\"|\'|\`/g, "");
                            }
                            fontFamily = fontFamilyArr[0];
                        }
                        if (domRect) {
                            if (domRect.height / lineHeight > 1.6) {
                                lineHeight *= 0.85;
                            }
                        }
                        fontSize = SizeConverter(fontSize);
                        lineHeight = parseFloat(lineHeight) ? SizeConverter(lineHeight) : fontSize * 1.14; /** 0.85*/;
                        const markerOutside = listStyle.includes('outside');
                        let markerX;
                        let markerY;
                        const outsideIndent = fontSize * 0.6 + 4.64; // approximated formula for calculating marker's indent, based on element's font-size
                        const markerSize = fontSize * 0.359 - 0.396; // approximated formula for calculating marker width, based on element's font-size
                        switch (listStyleType) {
                            case "disc": case "circle": {
                                markerX = x + (markerOutside ? - outsideIndent : 0);
                                const radius = markerSize / 2;
                                const isDisk = listStyleType === "disc";
                                markerY = y + lineHeight / 2 + markerSize / 2;
                                await workerResolver(pdfWorker, `setLineWidth`, +isDisk);
                                if (isDisk) {
                                    await workerResolver(pdfWorker, `circle`, markerX, markerY, radius, 'F');
                                } else {
                                    await workerResolver(pdfWorker, `circle`, markerX, markerY, radius);
                                }
                                break;
                            }
                            case `square`: {
                                markerX = x + (markerOutside ? -outsideIndent : 0);
                                const squareSideSize = markerSize;
                                markerY = y + fontSize / 2 - squareSideSize / 2;
                                await workerResolver(pdfWorker, `setLineWidth`, 0);
                                await workerResolver(pdfWorker, `rect`, markerX, markerY, squareSideSize, squareSideSize, 'F');
                                break;
                            }
                            case "decimal":
                            case "lower-alpha":
                            case "upper-alpha":
                            case "lower-latin":
                            case "upper-latin":
                            case "lower-roman":
                            case "upper-roman": {
                                await workerResolver(pdfWorker, `loadCustomFontAsync`, fontFamily, fontStyle || 'normal');
                                await workerResolver(pdfWorker, `setFontSize`, fontSize);
                                await workerResolver(pdfWorker, `setFont`, fontFamily, 'normal');
                                markerY = y + (lineHeight - fontSize) / 2 + fontSize * 0.85;
                                const isUpper = listStyleType.includes('upper');
                                let textValue = '';
                                const digitOrCharCounter = (
                                    listStyleType === 'decimal'
                                    || listStyleType.includes('roman')
                                ) ? 0 : 96;
                                // 96 - is the first lower latin index in ascii 

                                const listItemDigitValue =
                                    element.parentNode.start
                                    + digitOrCharCounter
                                    + [...element.parentElement.childNodes]
                                        .filter((childNode) => childNode.nodeName === 'LI')
                                        .indexOf(element);
                                if (digitOrCharCounter) { //char
                                    textValue = String.fromCharCode(listItemDigitValue);
                                } else { //decimal or roman
                                    textValue = (listStyleType === 'decimal')
                                        ? String(listItemDigitValue)
                                        : ConvertDecToRom(listItemDigitValue);
                                }

                                if (isUpper) {
                                    textValue = textValue.toUpperCase();
                                }
                                textValue += postSymbol;
                                const textWidth = await workerResolver(pdfWorker, `getTextWidth`, textValue);
                                markerX = x + (markerOutside ? -(3 + textWidth) : 0);
                                await workerResolver(pdfWorker, `text`, markerX, markerY, textValue);
                                break;
                            }
                        }
                    }
                    //break;
                }
                default: {
                    if (processSigns) {
                        if (element.hasAttribute('data-esign-field-id') &&
                            element.hasAttribute('data-esign-id') &&
                            element.hasAttribute('data-esign-h') &&
                            element.hasAttribute('data-esign-field-type') &&
                            ![...pageElement.classList].includes('watermark')) {
                            const IsOptional = element.getAttribute('data-esign-optional');
                            const Type = element.getAttribute('data-esign-field-type');
                            const parent = element.getAttribute('data-esign-parent');
                            const parentValue = element.getAttribute('data-esign-parent-value');
                            const preselectedValue = element.getAttribute('data-esign-preselected-value');
                            const ValidationType = element.getAttribute('data-esign-validation');
                            const TextAlignX = element.getAttribute('data-esign-text-align-x');
                            const TextSize = element.getAttribute(ESIGN_ATTRIBUTES.TEXT_FONT_SIZE);
                            const TextMaxCharacters = element.getAttribute(ESIGN_ATTRIBUTES.TEXT_LENGTH_LINE);
                            const TextLines = element.getAttribute(ESIGN_ATTRIBUTES.TEXT_LINE_COUNT);
                            const elementMetaData = {
                                FieldIdentifier: element.getAttribute('data-esign-field-id'),
                                Type,
                                Group: element.getAttribute('data-esign-group-id'),
                                Parent: element.getAttribute('data-esign-parent'),
                                IsRequired: !!element.getAttribute('data-esign-required'),
                                SignerIdentifier: element.getAttribute('data-esign-id'),
                                SignerType: element.getAttribute('data-esign-h'),
                                ...(parent) && { Parent: parent, ParentValue: parentValue },
                                ...(preselectedValue) && { PreselectedValue: preselectedValue },
                                ...(IsOptional) && { IsOptional },
                                ...(Type === 'Text' && ValidationType) && { ValidationType },
                                ...(Type === 'Text' && TextAlignX) && { TextAlignX },
                                ...(Type === 'Text' && TextSize) && { TextSize },
                                ...(Type === 'Text' && TextMaxCharacters) && { TextMaxCharacters },
                                ...(Type === 'Text' && TextLines) && { TextLines }
                            }

                            const elementPositionData = {
                                X: SizeConverter(domRect.left - pageDomRect.left),
                                Y: SizeConverter(domRect.top - pageDomRect.top),
                                Height: SizeConverter(domRect.height),
                                Width: SizeConverter(domRect.width)
                            }
                            const field = {
                                Page: pageIndex,
                                ...elementPositionData,
                                ...elementMetaData
                            }
                            //if (!pdfDocument.eSignFields[processSigns]) {
                            //    Object.assign(pdfDocument.eSignFields, { [processSigns]: [] });
                            //}
                            //if (!pdfDocument.eSignFields[processSigns].some(r => r.FieldIdentifier === field.FieldIdentifier)) {
                            //    pdfDocument.eSignFields[processSigns].push(field);
                            //}

                            await workerResolver(pdfWorker, 'pushEsignField', processSigns, field);
                        }
                        //pdfDocument.process(element, pageElement, pageDomRect, processSigns, pageIndex);
                        /* if (element.className && element.className.match(/signer-person\s+bc\d+/)) {
                            let signPlaceDiv = element.getElementsByClassName("signer-esign empty");
                            if (signPlaceDiv) {
                                signPlaceDiv = signPlaceDiv[0];
                                let signerName, docSignerId;
                                const signerID = element.className.match(/bc\d{1,2}/)[0];
                                signerName = element.getElementsByClassName("signer-name");
                                if (signerName.length === 1 && signerName[0].textContent) {
                                    docSignerId = signerName[0].getAttribute('data-id');
                                    signerName = signerName[0].textContent;                                    
                                } else {
                                    signerName = "signer name";
                                }
                                const pageIdAttribute = pageElement.getAttribute('id');
                                const pageNumber = +pageIdAttribute.replace(/[^0-9]/g, '');
                                const signRect = signPlaceDiv.getBoundingClientRect();                                
                                const signX = SizeConverter(signRect.left - pageDomRect.left);
                                const signY = SizeConverter(signRect.top - pageDomRect.top);
                                const signTagName = pdfDocument.getSignTag(signerName, signerID, SizeConverter(signRect.width), SizeConverter(signRect.height), signX, signY, pageNumber, docSignerId);

                                pdfDocument.setFont("Helvetica", "normal");
                                pdfDocument.setFontSize(1);
                                pdfDocument.setTextColor(0);

                                let datePlaceDiv = element.getElementsByClassName("signer-date-field");
                                if (datePlaceDiv) {
                                    datePlaceDiv = datePlaceDiv[0];
                                    const dateRect = datePlaceDiv.getBoundingClientRect();
                                    const dateYOffset = dateRect.height > 13 ? SizeConverter(dateRect.height-13)/2 : 0;
                                    const dateX = SizeConverter(dateRect.left - pageDomRect.left);
                                    const dateY = SizeConverter(dateRect.top - pageDomRect.top) + dateYOffset;
                                    const dateTagName = pdfDocument.getDateTag(signerName, signerID, SizeConverter(dateRect.width), SizeConverter(dateRect.height) - dateYOffset, dateX, dateY, pageNumber);
                                    pdfDocument.text(dateTagName, dateX, dateY);
                                }
                                pdfDocument.text(signTagName, signX, signY);

                            }
                        } */
                    }
                    let beforePseudoElementOutline = 0;
                    if (needToProcessPseudoElement(beforeComputedStyles)) {
                        if (beforeComputedStyles.width === 'auto') {
                            const r = element.getBoundingClientRect();
                            element.style.outline = '3px solid red';
                            element.style.backgroundColor = 'rgba(255,0,0,0.3)';
                            console.log('[DEBUG ::before auto width]',
                                'tag:', element.tagName,
                                'id:', element.id,
                                'class:', element.className,
                                'rect:', JSON.stringify({ x: Math.round(r.x), y: Math.round(r.y), w: Math.round(r.width), h: Math.round(r.height) }),
                                'outerHTML:', element.outerHTML.substring(0, 300)
                            );
                        }
                        await processPseudoElementAsync("before", pdfWorker, beforeComputedStyles, computedStyles, domRect, pageDomRect, hqImages);
                        if (beforeComputedStyles.width) {
                            beforePseudoElementOutline += SizeConverter(beforeComputedStyles.width);
                        }
                        if (beforeComputedStyles.marginRight && parseFloat(beforeComputedStyles.marginRight)) {
                            beforePseudoElementOutline += SizeConverter(beforeComputedStyles.marginRight);
                        }
                    }
                    if (computedStyles) {
                        x = SizeConverter(domRect.left - pageDomRect.left);
                        y = SizeConverter(domRect.top - pageDomRect.top);
                        const { borderColor, backgroundColor, borderWidth, backgroundImage, outline, transform, zIndex } = computedStyles;
                        let { width, height, backgroundSize, backgroundPosition } = computedStyles;
                        const baseBackgroundSize = backgroundSize;
                        width = SizeConverter(domRect.width);
                        height = SizeConverter(domRect.height);

                        if (transform && transform.match(transformMatrixRegex)) {
                            const matrixValues = transform.match(/\-?\d+(\.\d+)?/g).map(value => parseFloat(value)); // getting array of 6 numbers
                            //rotate coordinates
                            const localeX1 = -width / 2;
                            const localeY1 = 0;
                            const localeX2 = width / 2;
                            const localeY2 = 0;

                            const rotatedX1 = matrixValues[0] * localeX1 + matrixValues[2] * localeY1;
                            const rotatedY1 = matrixValues[1] * localeX1 + matrixValues[3] * localeY1;
                            const rotatedX2 = matrixValues[0] * localeX2 + matrixValues[2] * localeY2;
                            const rotatedY2 = matrixValues[1] * localeX2 + matrixValues[3] * localeY2;

                            const x1 = x + (rotatedX1 - localeX1);
                            const y1 = y + (rotatedY1 - localeY1);
                            const x2 = x + (rotatedX2 - localeX2) + width;
                            const y2 = y + (rotatedY2 - localeY2);
                            if (backgroundColor) {
                                const _backgroundColor = RGBParser(backgroundColor)
                                if (_backgroundColor.length === 3 || _backgroundColor[3] !== 0) {
                                    await workerResolver(pdfWorker, `setDrawColor`, _backgroundColor[0], _backgroundColor[1], _backgroundColor[2]);
                                    await workerResolver(pdfWorker, `setLineWidth`, height);
                                    await workerResolver(pdfWorker, `line`, x1, y1, x2, y2);
                                }
                            }
                        } else {
                            let values;
                            let top = 0, bottom = 0, left = 0, right = 0;
                            if (borderWidth) {
                                let borderColors = BorderColorParser(borderColor);
                                if (!borderColors) {
                                    borderColors = colorParse(borderColor).values
                                    if (!borderColors.length) {
                                        borderColors = {
                                            top: ("rgb(0, 0, 0)"),
                                            bottom: ("rgb(0, 0, 0)"),
                                            right: ("rgb(0, 0, 0)"),
                                            left: ("rgb(0, 0, 0)")
                                        }
                                    }
                                    if (borderColors.length === 3) {
                                        const bColorRGBString = `rgb(${borderColors[0]}, ${borderColors[1]}, ${borderColors[2]})`;
                                        borderColors = {
                                            top: bColorRGBString,
                                            bottom: bColorRGBString,
                                            right: bColorRGBString,
                                            left: bColorRGBString
                                        }
                                    }
                                }
                                const borderWidthValues = SidesParser(borderWidth);
                                top = SizeConverter(borderWidthValues.top);
                                bottom = SizeConverter(borderWidthValues.bottom);
                                left = SizeConverter(borderWidthValues.left);
                                right = SizeConverter(borderWidthValues.right);

                                if (borderColors) {
                                    // add lines in buffer to process them in future
                                    if (zIndex && parseInt(zIndex)) {
                                        if (!buildPDFObjectAsync.borderBuffer) {
                                            buildPDFObjectAsync.borderBuffer = [];
                                        }
                                        const borders = {};
                                        borders.zIndex = parseInt(zIndex);
                                        borders.values = [];
                                        if (top > 0) {
                                            const topBorderValue = {
                                                color: colorParse(borderColors.top).values,
                                                lineWidth: top,
                                                x1: x,
                                                y1: y + top / 2,
                                                x2: x + width,
                                                y2: y + top / 2
                                            }
                                            borders.values.push(topBorderValue);
                                        }
                                        if (bottom > 0) {
                                            const bottomBorderValue = {
                                                color: colorParse(borderColors.bottom).values,
                                                lineWidth: bottom,
                                                x1: x,
                                                y1: y + height - bottom / 2,
                                                x2: x + width,
                                                y2: y + height - bottom / 2
                                            }
                                            borders.values.push(bottomBorderValue);
                                        }
                                        if (left > 0) {
                                            const leftBorderValue = {
                                                color: colorParse(borderColors.left).values,
                                                lineWidth: left,
                                                x1: x + left / 2,
                                                y1: y,
                                                x2: x + left / 2,
                                                y2: y + height
                                            }
                                            borders.values.push(leftBorderValue);
                                        }
                                        if (right > 0) {
                                            const rightBorderValue = {
                                                color: colorParse(borderColors.right).values,
                                                lineWidth: right,
                                                x1: x + width - right / 2,
                                                y1: y,
                                                x2: x + width - right / 2,
                                                y2: y + height
                                            }
                                            borders.values.push(rightBorderValue);
                                        }
                                        buildPDFObjectAsync.borderBuffer.push(borders);
                                    } else {
                                        //border lines generating
                                        if (top > 0) {
                                            //top line
                                            values = colorParse(borderColors.top).values;
                                            await workerResolver(pdfWorker, `setDrawColor`, values[0], values[1], values[2]);
                                            await workerResolver(pdfWorker, `setLineWidth`, top);
                                            await workerResolver(pdfWorker, `line`, x, y + top / 2, x + width, y + top / 2);
                                        }
                                        if (bottom > 0) {
                                            //bottom line
                                            values = colorParse(borderColors.bottom).values;
                                            await workerResolver(pdfWorker, `setDrawColor`, values[0], values[1], values[2]);
                                            await workerResolver(pdfWorker, `setLineWidth`, bottom);
                                            await workerResolver(pdfWorker, `line`, x, y + height - bottom / 2, x + width, y + height - bottom / 2);
                                        }
                                        if (left > 0) {
                                            //left line
                                            values = colorParse(borderColors.left).values;
                                            await workerResolver(pdfWorker, `setDrawColor`, values[0], values[1], values[2]);
                                            await workerResolver(pdfWorker, `setLineWidth`, left);
                                            await workerResolver(pdfWorker, `line`, x + left / 2, y, x + left / 2, y + height);
                                        }
                                        if (right > 0) {
                                            //right line
                                            values = colorParse(borderColors.right).values;
                                            await workerResolver(pdfWorker, `setDrawColor`, values[0], values[1], values[2]);
                                            await workerResolver(pdfWorker, `setLineWidth`, right);
                                            await workerResolver(pdfWorker, `line`, x + width - right / 2, y, x + width - right / 2, y + height);
                                        }
                                    }
                                }
                            }
                            if (backgroundColor) {
                                const _backgroundColor = RGBParser(backgroundColor)
                                if (_backgroundColor.length === 3 || _backgroundColor[3] !== 0) {
                                    await workerResolver(pdfWorker, `setDrawColor`, 0);
                                    await workerResolver(pdfWorker, `setFillColor`, _backgroundColor[0], _backgroundColor[1], _backgroundColor[2]);
                                    await workerResolver(pdfWorker, `rect`, x + left, y + top, width - left - right, height - top - bottom, 'F');
                                }
                            }
                            if (backgroundImage && backgroundImage.includes('url(')) {
                                let backgroundSizeNeedToBeIncreased = false;
                                let backgroundWidth = 0;
                                let backgroundHeight = 0;
                                backgroundSize = backgroundSize && backgroundSize.match(/\d+(\.\d+)*\D+[ ]*/g);
                                if (backgroundSize) {
                                    backgroundWidth = SizeConverter(backgroundSize[0]);
                                    backgroundHeight = backgroundSize[1] ? SizeConverter(backgroundSize[1]) : height;
                                    if (backgroundSize[0]) {
                                        backgroundSizeNeedToBeIncreased = true;
                                    }
                                }
                                backgroundPosition = backgroundPosition && backgroundPosition.match(/(\d+\%)/g);
                                if (backgroundPosition) {
                                    backgroundPosition = backgroundPosition.map(el => parseFloat(el));
                                    if (backgroundPosition[0] > 0) { // change X coordinate
                                        x += (width - backgroundWidth) * backgroundPosition[0] / 100;
                                    }
                                    if (backgroundPosition[1] > 0) { // change Y coordinate
                                        y += (height - backgroundHeight) * backgroundPosition[1] / 100;
                                    }
                                }

                                const urlStartIndex = backgroundImage.indexOf("(") + 1;
                                const urlEndIndex = backgroundImage.indexOf(")") - 1;
                                let imageSource = backgroundImage.slice(urlStartIndex + 1, urlEndIndex), svgSource;
                                const isCachedImage = await workerResolver(pdfWorker, `isCachedImage`, imageSource);
                                let isImageBroken = false;
                                if (!isCachedImage) {
                                    const isSvgImage = await workerResolver(pdfWorker, `isSVGImageAsync`, imageSource);
                                    if (isSvgImage === undefined) {
                                        isImageBroken = true;
                                    }
                                    if (isSvgImage) {
                                        svgSource = imageSource;
                                        if (baseBackgroundSize === 'contain' || baseBackgroundSize === 'auto') {
                                            backgroundHeight = height;
                                            backgroundWidth = width;
                                        }
                                        imageSource = await SvgToPng(
                                            svgSource,
                                            backgroundHeight / (backgroundSizeNeedToBeIncreased ? 0.75 : 1),
                                            backgroundWidth / (backgroundSizeNeedToBeIncreased ? 0.75 : 1)
                                        );
                                    }
                                }
                                if (!isImageBroken) {
                                    const { imageData } = await workerResolver(pdfWorker, `getImage`, {
                                        svgSource,
                                        imageSource,
                                        ...(backgroundWidth && backgroundHeight ? {
                                            forcedWidth: backgroundWidth / (backgroundSizeNeedToBeIncreased ? 0.75 : 1),
                                            forcedHeight: backgroundHeight / (backgroundSizeNeedToBeIncreased ? 0.75 : 1)
                                        } : {})
                                    });
                                    if (imageData) {
                                        if (!baseBackgroundSize || baseBackgroundSize === 'auto' || baseBackgroundSize === 'contain') {
                                            backgroundHeight = height;
                                            backgroundWidth = width;
                                        }
                                        if (backgroundWidth && backgroundHeight) {
                                            await workerResolver(
                                                pdfWorker,
                                                `addImage`,
                                                imageData,
                                                `SLOW`,
                                                x,
                                                y,
                                                backgroundWidth,
                                                backgroundHeight);
                                        } else {
                                            await workerResolver(pdfWorker, `addImage`, imageData, `SLOW`, x, y);
                                        }
                                    }
                                }
                            }
                            if (outline) {
                                const outlineWidth = SizeConverter(outline.match(/\d+\.*\d*([a-z]{2})/i)[0]);
                                const outlineColor = RGBParser(outline);
                                if ((outlineColor.length === 3 || outlineColor[3] !== 0) && outlineWidth) {
                                    await workerResolver(pdfWorker, `setDrawColor`, outlineColor[0], outlineColor[1], outlineColor[2]);
                                    await workerResolver(pdfWorker, `setLineWidth`, outlineWidth);
                                    await workerResolver(pdfWorker, `line`, x - outlineWidth, y - outlineWidth / 2, x + width + outlineWidth, y - outlineWidth / 2);                   // top line
                                    await workerResolver(pdfWorker, `line`, x - outlineWidth, y + height + outlineWidth / 2, x + width + outlineWidth, y + height + outlineWidth / 2); // bottom line
                                    await workerResolver(pdfWorker, `line`, x - outlineWidth / 2, y - outlineWidth, x - outlineWidth / 2, y + height + outlineWidth);                  // left line
                                    await workerResolver(pdfWorker, `line`, x + width + outlineWidth / 2, y - outlineWidth, x + width + outlineWidth / 2, y + height + outlineWidth);  // right line
                                }
                            }
                        }
                    }
                    for (const childElement of childNodes) {
                        await buildPDFObjectAsync({ pdfWorker, documentBody, element: childElement, pageElement, paragraphObjects, processSigns, pageIndex, nestingLevel, parentsBeforePseudoElementOutline: beforePseudoElementOutline, hqImages, textFormatter });
                    }

                    if (needToProcessPseudoElement(afterComputedStyles)) {
                        if (afterComputedStyles.width === 'auto') {
                            const r = element.getBoundingClientRect();
                            element.style.outline = '3px solid blue';
                            element.style.backgroundColor = 'rgba(0,0,255,0.3)';
                            console.log('[DEBUG ::after auto width]',
                                'tag:', element.tagName,
                                'id:', element.id,
                                'class:', element.className,
                                'rect:', JSON.stringify({ x: Math.round(r.x), y: Math.round(r.y), w: Math.round(r.width), h: Math.round(r.height) }),
                                'outerHTML:', element.outerHTML.substring(0, 300)
                            );
                        }
                        let { fontFamily, fontStyle, fontSize } = computedStyles;
                        const fontFamilyArr = fontFamily.split(",");
                        if (fontFamilyArr) {
                            for (let i = 0; i < fontFamilyArr.length; i++) {
                                fontFamilyArr[i] = fontFamilyArr[i].trim().replace(/\"|\'|\`/g, "");
                            }
                            fontFamily = fontFamilyArr[0];
                        }
                        await workerResolver(pdfWorker, `loadCustomFontAsync`, fontFamily, fontStyle || "normal");
                        await workerResolver(pdfWorker, `setFont`, fontFamily, fontStyle);
                        await workerResolver(pdfWorker, `setFontSize`, SizeConverter(fontSize));
                        const parentTextContentWidth = await workerResolver(pdfWorker, `getTextWidth`, element.textContent || "");
                        await processPseudoElementAsync("after", pdfWorker, afterComputedStyles, computedStyles, domRect, pageDomRect, hqImages, parentTextContentWidth / 0.75);
                    }
                    break;
                }
            }
            break;
        }
        case Node.TEXT_NODE: {
            if (element.textContent.trim() === ``) {
                break;
            }
            let itemNode = element.parentNode;
            const paragraphNode = itemNode.closest(elementSelector);
            let itemRectData;
            if (!paragraphNode.isSameNode(itemNode)) {
                const pageDomRect = pageElement.getBoundingClientRect();
                const pageDomRectScroll = {
                    top: documentBody.scrollTop,
                    left: documentBody.scrollLeft
                }
                const itemDomRect = itemNode.getBoundingClientRect();

                const itemDomRectScroll = {
                    top: documentBody.scrollTop,
                    left: documentBody.scrollLeft
                }
                const itemNodeStyles = getBasicNodeData(itemNode).computedStyles;
                itemRectData = {
                    x: SizeConverter(itemDomRect.left - pageDomRect.left + (itemDomRectScroll.left | 0) - (pageDomRectScroll.left | 0)),
                    y: SizeConverter(itemDomRect.top - pageDomRect.top + (itemDomRectScroll.top | 0) - (pageDomRectScroll.top | 0)),
                    width: SizeConverter(itemDomRect.width),
                    height: SizeConverter(itemDomRect.height),
                    padding: itemNodeStyles.padding,
                    lineHeight: SizeConverter(LineHeightCalculator(itemNodeStyles, element)) + 'pt',
                    justifyContent: itemNodeStyles.justifyContent,
                    textAlign: itemNodeStyles.textAlign,
                    textAlignLast: itemNodeStyles.textAlignLast,
                    display: itemNodeStyles.display,
                    displayFlexDirection: itemNodeStyles.flexDirection || undefined
                };
            }
            const domRectHeight = paragraphNode.getBoundingClientRect().height;
            const { computedStyles } = getBasicNodeData(itemNode);
            const { fontStyle, fontSize, fontWeight, color, margin, webkitTextDecorationsInEffect, textAlign, textAlignLast, textTransform } = computedStyles;
            let { textDecoration } = computedStyles;
            if (((textDecoration && textDecoration.match("none")) || !textDecoration) && (webkitTextDecorationsInEffect && !webkitTextDecorationsInEffect.match("none"))) {
                textDecoration = webkitTextDecorationsInEffect;
            }
            let { fontFamily } = computedStyles;
            const fontFamilyArr = fontFamily.split(",");
            if (fontFamilyArr) {
                for (let i = 0; i < fontFamilyArr.length; i++) {
                    //fontFamilyArr[i] = fontFamilyArr[i].trim();
                    fontFamilyArr[i] = fontFamilyArr[i].trim().replace(/\"|\'|\`/g, "");
                    //if (!fontFamilyArr[i].startsWith("'")) {
                    //    fontFamilyArr[i] = `'${fontFamilyArr[i]}`;
                    //}
                    //if (!fontFamilyArr[i].endsWith("'")) {
                    //    fontFamilyArr[i] = `${fontFamilyArr[i]}'`;
                    //}
                }
                //fontFamily = fontFamilyArr.join(", ").replace(/\"/g, '');
                fontFamily = fontFamilyArr[0];
            }

            const cStyles = getBasicNodeData(paragraphNode).computedStyles;
            const saveLineBreaks = (cStyles.whiteSpace === 'pre-line');

            let paragraphObject = paragraphObjects.find(object => object.paragraphNode.isSameNode(paragraphNode));
            if (!paragraphObject) {
                const paragraphChildNodes = [...paragraphNode.children];
                const isChartLabel =
                    paragraphChildNodes.filter(ch => ch.tagName.toLowerCase() == 'svg').length ==
                    paragraphChildNodes.filter(ch => ch.tagName.toLowerCase() == 'span').length == 1 &&
                    element.parentElement.tagName && element.parentElement.tagName.toLowerCase() === 'span';
                if (isChartLabel) {
                    const newDomRectHeight = element.parentNode.getBoundingClientRect().height;
                    paragraphObject = {
                        items: [],
                        paragraphNode: element.parentNode,
                        styles: {
                            lineHeight: SizeConverter(LineHeightCalculator(cStyles, element)) + 'pt',
                            domRectHeight: SizeConverter(newDomRectHeight),
                            padding: cStyles.padding,
                            textAlign: cStyles.textAlign,
                            textAlignLast: cStyles.textAlignLast,
                            alignItems: cStyles.alignItems,
                            justifyContent: cStyles.justifyContent,
                            borderWidth: cStyles.borderWidth,
                            textOverflow: cStyles.textOverflow,
                            whiteSpace: cStyles.whiteSpace,
                            firstLineIndent: SizeConverter(cStyles.textIndent),
                            display: cStyles.display,
                            displayFlexDirection: cStyles.flexDirection || undefined
                        },
                        beforePseudoElementOutline: parentsBeforePseudoElementOutline
                    }
                }
                else {
                    paragraphObject = {
                        items: [],
                        paragraphNode,
                        styles: {
                            lineHeight: SizeConverter(LineHeightCalculator(cStyles, element)) + 'pt',
                            domRectHeight: SizeConverter(domRectHeight),
                            padding: cStyles.padding,
                            textAlign: cStyles.textAlign,
                            textAlignLast: cStyles.textAlignLast,
                            alignItems: cStyles.alignItems,
                            justifyContent: cStyles.justifyContent,
                            borderWidth: cStyles.borderWidth,
                            textOverflow: cStyles.textOverflow,
                            whiteSpace: cStyles.whiteSpace,
                            firstLineIndent: SizeConverter(cStyles.textIndent),
                            display: cStyles.display,
                            displayFlexDirection: cStyles.flexDirection || undefined
                        },
                        beforePseudoElementOutline: parentsBeforePseudoElementOutline
                    }
                }
                paragraphObjects.push(paragraphObject)
            }
            let isSup = false;
            if (element.parentNode) {
                isSup = !_.isNil(element.parentNode.closest('sup'));
            }
            
            let itemText = isSup ? element.textContent : textFormatter(element.textContent, saveLineBreaks, paragraphObject.items.length);
            if (textTransform) {
                if (textTransform === "uppercase") {
                    itemText = itemText.toUpperCase();
                }
                if (textTransform === "capitalize") {
                    const isSpaced = itemText.startsWith(' ');
                    itemText = itemText.trimLeft();
                    itemText = itemText.charAt(0).toUpperCase() + itemText.substring(1);
                    if (isSpaced) {
                        itemText = ' ' + itemText;
                    }
                }
                if (textTransform === "lowercase") {
                    itemText = itemText.toLowerCase();
                }
            }
            const itemData = {
                nodeType: element.nodeType,
                itemRectData,
                fontStyle,
                fontFamily,
                fontWeight,
                fontSize: SizeConverter(fontSize),
                color: `rgb(${colorParse(color ?? '').values.join(', ')})`,
                text: itemText,
                margin,
                textAlign,
                textAlignLast,
                textDecoration,
                isSup
            };

            const itemsLength = paragraphObject.items.length;
            if (itemsLength > 0
                && paragraphObject.items[itemsLength - 1].nodeType === Node.TEXT_NODE
                && paragraphObject.items[itemsLength - 1].text.endsWith(nbsp)) {
                paragraphObject.items[itemsLength - 1].text += itemData.text.replace(/^\s/, '');
            }
            else {
                paragraphObject.items.push(itemData);
            }

            break;
        }
    }
    if (nestingLevel === 1) {
        if (buildPDFObjectAsync.borderBuffer) {
            buildPDFObjectAsync.borderBuffer.sort((a, b) => { a.zIndex - b.zIndex });
            for (let i = 0; i < buildPDFObjectAsync.borderBuffer.length; i++) {
                for (let j = 0; j < buildPDFObjectAsync.borderBuffer[i].values.length; j++) {
                    const { color, lineWidth, x1, x2, y1, y2 } = buildPDFObjectAsync.borderBuffer[i].values[j];
                    await workerResolver(pdfWorker, `setDrawColor`, color[0], color[1], color[2]);
                    await workerResolver(pdfWorker, `setLineWidth`, lineWidth);
                    await workerResolver(pdfWorker, `line`, x1, y1, x2, y2);
                }
            }
            buildPDFObjectAsync.borderBuffer = [];
        }

    }
}

/**
 * Method that draw bar-codes;
 * Used to call it in the end of page-processing to be sure that barcodes are on top of content.
 */
export const renderBarcodesAsync = async () => {
    if (buildPDFObjectAsync.barcodeRender_temp) {
        for (const barcodeRenderCallback of buildPDFObjectAsync.barcodeRender_temp) {
            await barcodeRenderCallback();
        };
        buildPDFObjectAsync.barcodeRender_temp = null;
    }
}

export const clearPDFTempData = () => {
    Object.keys(buildPDFObjectAsync).forEach((key) => {
        if (key.endsWith('_temp')) {
            delete (buildPDFObjectAsync[key]);
        }
    });
}
